import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumb from '../../components/ui/Breadcrumb';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import InventorySidebar from './components/InventorySidebar';
import InventorySummary from './components/InventorySummary';
import InventoryTable from './components/InventoryTable';
import BarcodeModal from './components/BarcodeModal';
import StockTransferModal from './components/StockTransferModal';
import InventoryAuditModal from './components/InventoryAuditModal';

const InventoryManagement = () => {
  const [filters, setFilters] = useState({
    search: '',
    design: 'all',
    size: 'all',
    stockStatus: 'all',
    location: 'all',
    minStock: '',
    maxStock: '',
    onlyBarcoded: false,
    includeReserved: true,
    showDefective: false
  });

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);
  const [modals, setModals] = useState({
    barcode: false,
    stockTransfer: false,
    inventoryAudit: false
  });

  // Mock inventory data
  const inventoryData = [
    {
      id: 'design-001',
      name: 'Floral Print Collection',
      category: 'Floral Designs',
      totalStock: 1250,
      reserved: 180,
      available: 1070,
      status: 'in-stock',
      location: 'Warehouse A',
      sizes: [
        {
          size: 'S',
          totalPieces: 200,
          reservedPieces: 25,
          availablePieces: 175,
          status: 'in-stock',
          location: 'Warehouse A',
          barcode: 'NJT-FP-S-001',
          pieces: [1, 2, 3, 4, 5]
        },
        {
          size: 'M',
          totalPieces: 350,
          reservedPieces: 50,
          availablePieces: 300,
          status: 'in-stock',
          location: 'Warehouse A',
          barcode: 'NJT-FP-M-001',
          pieces: [6, 7, 8, 9, 10]
        },
        {
          size: 'L',
          totalPieces: 400,
          reservedPieces: 60,
          availablePieces: 340,
          status: 'in-stock',
          location: 'Warehouse A',
          barcode: 'NJT-FP-L-001',
          pieces: [11, 12, 13, 14, 15]
        },
        {
          size: 'XL',
          totalPieces: 200,
          reservedPieces: 30,
          availablePieces: 170,
          status: 'in-stock',
          location: 'Warehouse A',
          barcode: 'NJT-FP-XL-001',
          pieces: [16, 17, 18, 19, 20]
        },
        {
          size: '2XL',
          totalPieces: 100,
          reservedPieces: 15,
          availablePieces: 85,
          status: 'low-stock',
          location: 'Warehouse A',
          barcode: 'NJT-FP-2XL-001',
          pieces: [21, 22, 23, 24, 25]
        }
      ]
    },
    {
      id: 'design-002',
      name: 'Geometric Pattern Series',
      category: 'Geometric Designs',
      totalStock: 890,
      reserved: 120,
      available: 770,
      status: 'in-stock',
      location: 'Warehouse B',
      sizes: [
        {
          size: 'S',
          totalPieces: 150,
          reservedPieces: 20,
          availablePieces: 130,
          status: 'in-stock',
          location: 'Warehouse B',
          barcode: 'NJT-GP-S-002',
          pieces: [26, 27, 28, 29, 30]
        },
        {
          size: 'M',
          totalPieces: 280,
          reservedPieces: 40,
          availablePieces: 240,
          status: 'in-stock',
          location: 'Warehouse B',
          barcode: 'NJT-GP-M-002',
          pieces: [31, 32, 33, 34, 35]
        },
        {
          size: 'L',
          totalPieces: 300,
          reservedPieces: 45,
          availablePieces: 255,
          status: 'in-stock',
          location: 'Warehouse B',
          barcode: 'NJT-GP-L-002',
          pieces: [36, 37, 38, 39, 40]
        },
        {
          size: 'XL',
          totalPieces: 120,
          reservedPieces: 12,
          availablePieces: 108,
          status: 'in-stock',
          location: 'Warehouse B',
          barcode: 'NJT-GP-XL-002',
          pieces: [41, 42, 43, 44, 45]
        },
        {
          size: '2XL',
          totalPieces: 40,
          reservedPieces: 3,
          availablePieces: 37,
          status: 'low-stock',
          location: 'Warehouse B',
          barcode: 'NJT-GP-2XL-002',
          pieces: [46, 47, 48, 49, 50]
        }
      ]
    },
    {
      id: 'design-003',
      name: 'Abstract Art Collection',
      category: 'Abstract Designs',
      totalStock: 650,
      reserved: 95,
      available: 555,
      status: 'in-stock',
      location: 'Production Floor',
      sizes: [
        {
          size: 'S',
          totalPieces: 100,
          reservedPieces: 15,
          availablePieces: 85,
          status: 'in-stock',
          location: 'Production Floor',
          barcode: 'NJT-AA-S-003',
          pieces: [51, 52, 53, 54, 55]
        },
        {
          size: 'M',
          totalPieces: 200,
          reservedPieces: 30,
          availablePieces: 170,
          status: 'in-stock',
          location: 'Production Floor',
          barcode: 'NJT-AA-M-003',
          pieces: [56, 57, 58, 59, 60]
        },
        {
          size: 'L',
          totalPieces: 220,
          reservedPieces: 35,
          availablePieces: 185,
          status: 'in-stock',
          location: 'Production Floor',
          barcode: 'NJT-AA-L-003',
          pieces: [61, 62, 63, 64, 65]
        },
        {
          size: 'XL',
          totalPieces: 100,
          reservedPieces: 12,
          availablePieces: 88,
          status: 'in-stock',
          location: 'Production Floor',
          barcode: 'NJT-AA-XL-003',
          pieces: [66, 67, 68, 69, 70]
        },
        {
          size: '2XL',
          totalPieces: 30,
          reservedPieces: 3,
          availablePieces: 27,
          status: 'low-stock',
          location: 'Production Floor',
          barcode: 'NJT-AA-2XL-003',
          pieces: [71, 72, 73, 74, 75]
        }
      ]
    },
    {
      id: 'design-004',
      name: 'Traditional Motif Range',
      category: 'Traditional Designs',
      totalStock: 420,
      reserved: 60,
      available: 360,
      status: 'low-stock',
      location: 'Quality Check',
      sizes: [
        {
          size: 'S',
          totalPieces: 80,
          reservedPieces: 10,
          availablePieces: 70,
          status: 'low-stock',
          location: 'Quality Check',
          barcode: 'NJT-TM-S-004',
          pieces: [76, 77, 78, 79, 80]
        },
        {
          size: 'M',
          totalPieces: 150,
          reservedPieces: 20,
          availablePieces: 130,
          status: 'in-stock',
          location: 'Quality Check',
          barcode: 'NJT-TM-M-004',
          pieces: [81, 82, 83, 84, 85]
        },
        {
          size: 'L',
          totalPieces: 120,
          reservedPieces: 18,
          availablePieces: 102,
          status: 'in-stock',
          location: 'Quality Check',
          barcode: 'NJT-TM-L-004',
          pieces: [86, 87, 88, 89, 90]
        },
        {
          size: 'XL',
          totalPieces: 50,
          reservedPieces: 8,
          availablePieces: 42,
          status: 'low-stock',
          location: 'Quality Check',
          barcode: 'NJT-TM-XL-004',
          pieces: [91, 92, 93, 94, 95]
        },
        {
          size: '2XL',
          totalPieces: 20,
          reservedPieces: 4,
          availablePieces: 16,
          status: 'low-stock',
          location: 'Quality Check',
          barcode: 'NJT-TM-2XL-004',
          pieces: [96, 97, 98, 99, 100]
        }
      ]
    }
  ];

  // Summary data calculation
  const summaryData = {
    totalPieces: inventoryData.reduce((sum, design) => sum + design.totalStock, 0),
    designCount: inventoryData.length,
    stockValue: inventoryData.reduce((sum, design) => sum + (design.totalStock * 450), 0),
    lowStockCount: inventoryData.filter(design => design.status === 'low-stock').length,
    reservedStock: inventoryData.reduce((sum, design) => sum + design.reserved, 0),
    availableStock: inventoryData.reduce((sum, design) => sum + design.available, 0)
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleClearFilters = () => {
    setFilters({
      search: '',
      design: 'all',
      size: 'all',
      stockStatus: 'all',
      location: 'all',
      minStock: '',
      maxStock: '',
      onlyBarcoded: false,
      includeReserved: true,
      showDefective: false
    });
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedItems(newSelection);
  };

  const openModal = (modalName) => {
    setModals(prev => ({ ...prev, [modalName]: true }));
  };

  const closeModal = (modalName) => {
    setModals(prev => ({ ...prev, [modalName]: false }));
  };

  const handleBarcodeGenerate = (items) => {
    console.log('Generating barcodes for:', items);
    // Implementation for barcode generation
  };

  const handleStockTransfer = (transferData) => {
    console.log('Processing stock transfer:', transferData);
    // Implementation for stock transfer
  };

  const handleInventoryAudit = (auditSettings) => {
    console.log('Starting inventory audit:', auditSettings);
    // Implementation for inventory audit
  };

  const handleViewHistory = (designId) => {
    console.log('Viewing history for design:', designId);
    // Implementation for viewing stock movement history
  };

  const handleExportData = () => {
    console.log('Exporting inventory data');
    // Implementation for data export
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Sidebar onCollapseChange={setIsSidebarCollapsed} />

      <div className={`pt-16 transition-all duration-300 ${isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>

        <div className="flex flex-col lg:flex-row">
          <InventorySidebar
            filters={filters}
            onFiltersChange={handleFiltersChange}
            onClearFilters={handleClearFilters}
          />

          <main className="flex-1 p-4 sm:p-6">


            {/* <Breadcrumb /> */}
            <Breadcrumb />
            {/* Page Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
              <div>
                <h1 className="text-3xl font-bold text-foreground">Inventory Management</h1>
                <p className="text-muted-foreground mt-1">
                  Comprehensive stock tracking with design, size, and piece-wise visibility
                </p>
              </div>

              <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:justify-end sm:gap-3 w-full sm:w-auto">
                <Button
                  variant="outline"
                  onClick={handleExportData}
                  iconName="Download"
                  iconPosition="left"
                  iconSize={16}
                >
                  Export Data
                </Button>
                <Button
                  variant="outline"
                  onClick={() => openModal('inventoryAudit')}
                  iconName="ClipboardCheck"
                  iconPosition="left"
                  iconSize={16}
                >
                  Inventory Audit
                </Button>
                <Button
                  variant="outline"
                  onClick={() => openModal('stockTransfer')}
                  disabled={selectedItems.length === 0}
                  iconName="ArrowRightLeft"
                  iconPosition="left"
                  iconSize={16}
                >
                  Stock Transfer
                </Button>
                <Button
                  variant="default"
                  onClick={() => openModal('barcode')}
                  disabled={selectedItems.length === 0}
                  iconName="QrCode"
                  iconPosition="left"
                  iconSize={16}
                >
                  Generate Barcodes
                </Button>
              </div>
            </div>

            {/* Summary Dashboard */}
            <InventorySummary summaryData={summaryData} />

            {/* Selection Info */}
            {selectedItems.length > 0 && (
              <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <Icon name="CheckCircle" size={20} className="text-primary" />
                    <span className="text-primary font-medium">
                      {selectedItems.length} item(s) selected
                    </span>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => setSelectedItems([])}
                    iconName="X"
                    iconPosition="left"
                    iconSize={14}
                    className="text-primary hover:text-primary"
                  >
                    Clear Selection
                  </Button>
                </div>
              </div>
            )}

            {/* Inventory Table */}
            <InventoryTable
              inventoryData={inventoryData}
              selectedItems={selectedItems}
              onSelectionChange={handleSelectionChange}
              onBarcodeGenerate={handleBarcodeGenerate}
              onStockTransfer={handleStockTransfer}
              onViewHistory={handleViewHistory}
            />
          </main>
        </div>
      </div>

      {/* Modals */}
      <BarcodeModal
        isOpen={modals.barcode}
        onClose={() => closeModal('barcode')}
        selectedItems={selectedItems}
        onGenerate={handleBarcodeGenerate}
      />

      <StockTransferModal
        isOpen={modals.stockTransfer}
        onClose={() => closeModal('stockTransfer')}
        selectedItems={selectedItems}
        onTransfer={handleStockTransfer}
      />

      <InventoryAuditModal
        isOpen={modals.inventoryAudit}
        onClose={() => closeModal('inventoryAudit')}
        onStartAudit={handleInventoryAudit}
      />
    </div>
  );
};

export default InventoryManagement;